import logo from '../assets/images/logo.png'; 

function Footer() {
  return (
    <div className="chat-footer text-center flex flex-row gap-2 justify-center">
      <a href="https://callbell.eu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
        <span className="text-xs">Powered by</span>
        <img src={logo} alt="Callbell Logo" />
      </a>
    </div>
  );
}

export default Footer;